var MechanicalAjaxForProduct = function ajaxConstructor(settings) {
  var default_Data = {
    container: "#infinteScroll",
    method: "scroll",
    callback: null,
    loadingText: "Loading...",
    pagination: "#infinitePagination",
    offset: 0,
  };

  var data = settings || {};
  this.data = Object.assign(default_Data, data);

  this.mechanicalProductClick = this.mechanicalProductClick.bind(this);
  this.mechanicalProductScroll = this.mechanicalProductScroll.bind(this);
  this.mechanicalProductDestroy = this.mechanicalProductDestroy.bind(this);
  this.mechanicalStopProductMultipleClicks = this.mechanicalStopProductMultipleClicks.bind(this);
  this.mechanicalProductPaginationlnView = this.mechanicalProductPaginationlnView.bind(this);

  this.mechanicalProductpagination = document.querySelector(this.data.pagination);
  this.mechanicalProductcontainer = document.querySelector(this.data.container);

  this.mechanicalProductInitialize();
};

MechanicalAjaxForProduct.prototype.mechanicalProductInitialize = function basedProductsInitializeTheCorrectFunctionsMethod() {
  if (this.mechanicalProductcontainer) {
    var initialidata = {
      click: this.mechanicalProductClick,
      scroll: this.mechanicalProductScroll,
    };
    if (initialidata[this.data.method]) {
      initialidata[this.data.method]();
    }
  }
};

MechanicalAjaxForProduct.prototype.mechanicalProductScroll = function productsPageScrolling() {
  if (this.mechanicalProductpagination) {
    document.addEventListener("scroll", this.mechanicalProductPaginationlnView);
    window.addEventListener("resize", this.mechanicalProductPaginationlnView);
    window.addEventListener("orientationchange", this.mechanicalProductPaginationlnView);
  }
};

MechanicalAjaxForProduct.prototype.mechanicalProductClick = function productsPageClicking() {
  if (this.mechanicalProductpagination) {
    this.nextPageLinkElement = this.mechanicalProductpagination.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.mechanicalStopProductMultipleClicks);
    }
  }
};

MechanicalAjaxForProduct.prototype.mechanicalStopProductMultipleClicks = function prouctPageHandleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

MechanicalAjaxForProduct.prototype.mechanicalProductPaginationlnView = function prouctPageHandleScrollEvent() {
  var top = this.mechanicalProductpagination.getBoundingClientRect().top - this.data.offset;
  var bottom = this.mechanicalProductpagination.getBoundingClientRect().bottom + this.data.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.mechanicalProductpagination.querySelector("a");
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.data.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

MechanicalAjaxForProduct.prototype.loadMore = function nextPageRequest() {
  var loaderElement = document.getElementById("loader");
  if (loaderElement) loaderElement.style.display = "block";

  setTimeout(() => {
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function success() {
      if (this.request.readyState === 4 && this.request.status === 200) {
        var cratedPagination = this.request.responseXML.querySelector(this.data.pagination);
        var cratedContaner = this.request.responseXML.querySelector(this.data.container);

        if (cratedPagination) {
          this.mechanicalProductpagination.innerHTML = cratedPagination.innerHTML;
        } else {
          this.mechanicalProductpagination.innerHTML = ""; // Remove pagination if none left
        }

        if (cratedContaner) {
          this.mechanicalProductcontainer.insertAdjacentHTML("beforeend", cratedContaner.innerHTML);
        }

        if (this.data.callback && typeof this.data.callback === "function") {
          this.data.callback(this.request.responseXML);
        }

        if (!this.request.responseXML.querySelector(`${this.data.pagination} a`)) {
          console.log("No more products to load.");
          this.removeScrollListener();
          if (loaderElement) loaderElement.style.display = "none";
        } else {
          this.mechanicalProductInitialize();
        }
      }
    }.bind(this);

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  }, 2000);
};

MechanicalAjaxForProduct.prototype.removeScrollListener = function removeProductScroll() {
  document.removeEventListener("scroll", this.mechanicalProductPaginationlnView);
  window.removeEventListener("resize", this.mechanicalProductPaginationlnView);
  window.removeEventListener("orientationchange", this.mechanicalProductPaginationlnView);
};

MechanicalAjaxForProduct.prototype.mechanicalProductDestroy = function removeProductReturnData() {
  var yereData = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  if (yereData[this.data.method]) {
    yereData[this.data.method]();
  }
  return this;
};

MechanicalAjaxForProduct.prototype.removeClickListener = function removeProductClick() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.mechanicalStopProductMultipleClicks);
  }
};


